<template>
  <div>
    404 PAGE NOT FOUND
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
